'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _DatePicker = require('./DatePicker.scss');

var _DatePicker2 = _interopRequireDefault(_DatePicker);

var _calendar = require('../../lib/react-datepicker/calendar');

var _calendar2 = _interopRequireDefault(_calendar);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _Time = require('@wix/wixrest-utils/dist/Time');

var _Time2 = _interopRequireDefault(_Time);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class(props) {
        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

        _this._onSelect = function (value) {
            _this.props.onSelect({ value: _Time2.default.serializeDate(value) });
        };

        _this._close = function () {
            _this.props.onSelect({ value: null });
        };

        _this.uniqueId = _lodash2.default.uniqueId();
        _this.state = {};
        return _this;
    }

    _class.prototype.componentWillMount = function componentWillMount() {
        if (this.props.locale) {
            _momentTimezone2.default.locale(this.props.locale);
        }
        if (this.props.timezone) {
            _momentTimezone2.default.tz.setDefault(this.props.timezone);
        }
    };

    _class.prototype.render = function render() {
        var _props = this.props,
            className = _props.className,
            selectedDate = _props.selectedDate,
            filterDate = _props.filterDate,
            excludeDates = _props.excludeDates,
            dateFormat = _props.dateFormat,
            minDate = _props.minDate,
            maxDate = _props.maxDate,
            rtl = _props.rtl,
            locale = _props.locale,
            timezone = _props.timezone;

        className += ' ' + _DatePicker2.default.datePicker;
        selectedDate = selectedDate ? _momentTimezone2.default.tz(selectedDate, timezone) : null;

        return _react2.default.createElement(
            'div',
            { className: className },
            _react2.default.createElement(
                'div',
                { className: _DatePicker2.default.innerWrapper + ' ' + (rtl ? _DatePicker2.default.rtl : _DatePicker2.default.ltr) },
                _react2.default.createElement(_calendar2.default, { id: this.uniqueId,
                    selected: selectedDate && _momentTimezone2.default.tz(selectedDate, timezone) || undefined,
                    onSelect: this._onSelect,
                    excludeDates: excludeDates,
                    filterDate: filterDate,
                    onlyMonthDays: true,
                    dateFormat: dateFormat,
                    locale: locale,
                    rtl: rtl,
                    timezone: timezone,
                    minDate: minDate && _momentTimezone2.default.tz(_Time2.default.serializeDate(minDate), timezone) || undefined,
                    maxDate: maxDate && _momentTimezone2.default.tz(_Time2.default.serializeDate(maxDate), timezone) || undefined })
            )
        );
    };

    return _class;
}(_react2.default.Component);

_class.displayName = 'DatePicker';

_class.defaultProps = function () {
    var now = (0, _momentTimezone2.default)();

    return {
        className: '',
        dateFormat: 'MMMM YYYY',
        minDate: now,
        locale: typeof window !== 'undefined' && window.__NORMALIZED_APP_LOCALE__ ? window.__NORMALIZED_APP_LOCALE__ : 'en'
    };
}();

exports.default = _class;